import styled, { css } from 'styled-components'
import { backgroundOrange, border1 } from '@/theme/colors'
import { media } from '@/theme/tokens'
import { Button } from '@components/Button'
import { ShellRow } from '@components/Page'

/* Full-bleed band on the same treatment as the public SiteHeader: cream ground
   and a hairline under it. The horizontal gutter lives on HeaderContent (the
   shared ShellRow) so the brand lines up with the page content below. */
export const HeaderContainer = styled.header`
	background: ${backgroundOrange};
	border-bottom: 1px solid ${border1};
	padding: 16px 0;

	${media.phone} {
		padding: 10px 0;
	}
`

export const HeaderContent = styled(ShellRow)`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 8px;
`

// The brand lockup is the shared @components/BrandMark atom (same as the
// public SiteHeader) — no local logo styles.

export const HeaderActions = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
`

/** A nav action: the ghost Button. `$collapse` leaves only the icon on phones. */
export const NavButton = styled(Button)<{ $collapse?: boolean }>`
	${({ $collapse }) =>
		$collapse &&
		css`
			${media.phone} {
				padding: 8px 8px;

				span {
					display: none;
				}
			}
		`}
`
